import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { faEye, faEyeSlash, IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { IPOSValidator } from '../../../common/validators/validators';
import { CreateAccountConstants } from '../create-account/constants/create-account.const';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { CognitoCallback, LoggedInCallback } from '../../../core/routing/interfaces/cognito.i';
import { LoginService } from '../../../core/routing/services/login/login.service.ts.service';
import { Router } from '@angular/router';
import { MyAccountService } from '../../../core/routing/services/my-account/my-account.service';
import { LoginConstants } from '../login/constants/login.constant';
import { Location } from '@angular/common';
import { CommonService } from '../../../common/services/common.service';

@Component({
  selector: 'iposcen-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit, CognitoCallback, LoggedInCallback, OnDestroy {

  changePwdPopup: boolean;
  changePWDForm: FormGroup;
  mandatoryPassword: string;
  isUpperCase: boolean;
  isLowerCase: boolean;
  isNumeric: boolean;
  isSymbol: boolean;
  isMaxChar: boolean;
  displayEyePassword: IconDefinition;
  displayCurrEyePassword: IconDefinition;
  fieldTextType: boolean;
  isSubmitted = false;
  placeholderPassword: string;
  dsiplayError: boolean;
  mandatoryConfPassword: string;
  placeholderCnfPassword: string;
  repeatFieldTextType: boolean;
  displayEyeCnfPassword: IconDefinition;
  mandatoryPasswordMatch: string;
  isPasswordMatch: boolean;
  mandatoryCurrentPassword: string;
  placeholderCurrentPassword: string;
  mandatoryfield: string;
  errorMessage: boolean;
  locationList = [];
  editAccountForm: FormGroup;
  countryHeading = GlobalConstants.COUNTRY;
  retailerNameHeading = GlobalConstants.RETAILER_NAME_SEARCH;
  storeNameHeading = GlobalConstants.STORE_NAME_HEADING;
  firstNameHeading = GlobalConstants.FIRST_NAME_HEADING;
  lastNameHeading = GlobalConstants.LAST_NAME_HEADING;
  emailAddressHeading = GlobalConstants.EMAIL_ADDRESS_HEADING;
  pwdSuccessModal: boolean;
  checkCurrPwd: boolean;
  incorrectCurrPwd: string;
  notApplicable: string;
  userAccountTitle: string;
  userAccountSuccessMsg: string;
  showErrorMessage: string;
  fieldCurrentTextType: boolean;
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  isUserAuthor: boolean = false;
  showRetailGif = false;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private myAccountService: MyAccountService,
    private location: Location,
    private cmnService: CommonService
  ) { }

  ngOnInit(): void {
    this.dsiplayError = true;
    this.checkCurrPwd = false;
    this.errorMessage = false;
    this.mandatoryPassword = CreateAccountConstants.MANDATORY_NEW_ACCOUNT_PASSWORD;
    this.mandatoryConfPassword = CreateAccountConstants.MANDATORY_CONFIRM_ACCOUNT_PASSWORD;
    this.mandatoryCurrentPassword = CreateAccountConstants.MANDATORY_CURRENT_PASSWORD;
    this.placeholderPassword = CreateAccountConstants.PLACEHOLDER_NEW_ACCOUNT_PASSWORD;
    this.placeholderCnfPassword = CreateAccountConstants.PLACEHOLDER_CONFIRM_ACCOUNT_PASSWORD;
    this.placeholderCurrentPassword = CreateAccountConstants.PLACEHOLDER_CURRENT_PASSWORD;
    this.mandatoryfield = CreateAccountConstants.MANDADTORY_REQUIRED_FIELD;
    this.incorrectCurrPwd = LoginConstants.INCORRECT_CURRENT_PASSWORD;
    this.notApplicable = GlobalConstants.NA;
    this.displayEyePassword = faEye;
    this.displayEyeCnfPassword = faEye;
    this.displayCurrEyePassword = faEye;
    this.loginService.isAuthenticated(this);
    this.getUserAccountDetails();
    this.changePWDForm = this.formBuilder.group(
      {
        currentPassword: new FormControl('', [
          Validators.required
        ]),
        password: new FormControl('', [
          Validators.required
        ]),
        cnfPassword: new FormControl('', [
          Validators.required
        ])
      },
      {
        validator: IPOSValidator.confirmedValidator('password', 'cnfPassword')
      }
    );
     
    this.editAccountForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: [''],
      location: [''],
      storeName: [''],
      retailerName: [''],
      emailNotification: ['']
    });

    this.mandatoryPasswordMatch = CreateAccountConstants.MANDATORY_PASSWORD_MATCH;
    if(this.userRole === "author"){
      this.isUserAuthor = true;
    }
    this.cmnService.getRetailGifValue
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(data => {
      if(data) {
        this.showRetailGif = true;
      }
    });
  }
  get formControls() {
    return this.changePWDForm.controls;
  }

  openChangePasswordPopup() {
    this.isSubmitted = false;
    this.isPasswordMatch = false;
    this.dsiplayError = false;
    this.checkCurrPwd = false;
    this.changePWDForm.reset();
    this.changePwdPopup = true;
  }

  closePopup() {
    this.changePwdPopup = false;
    this.changePWDForm.reset();
  }

  checkPasswordValidation(currentValue: string) {
    this.isNumeric = GlobalConstants.NUMERIC_REGEX.test(currentValue);
    this.isUpperCase = GlobalConstants.UPPER_CASE_REGEX.test(currentValue);
    this.isLowerCase = GlobalConstants.LOWER_CASE_REGEX.test(currentValue);
    this.isSymbol = GlobalConstants.ISSYMBOL.test(currentValue);
    this.isMaxChar = currentValue.length > CreateAccountConstants.SEVEN;
    this.dsiplayError = !(this.isNumeric && this.isUpperCase && this.isLowerCase && this.isSymbol && this.isMaxChar);
    if (this.changePWDForm.controls.cnfPassword.value) {
      this.isPasswordMatch = this.changePWDForm.controls.cnfPassword.value === currentValue;
    }
    this.errorMessage = false;
    this.showErrorMessage = '';
  }

  checkCurrentPassword(cpvalue: string) {
    this.checkCurrPwd = cpvalue ? true : false;
    this.errorMessage = false;
    this.showErrorMessage = '';
  }

  changeAccountPassword() {
    this.isSubmitted = true;
    if(this.changePWDForm.controls.currentPassword.value === this.changePWDForm.controls.password.value) {
      this.errorMessage = true;
      this.showErrorMessage = GlobalConstants.SAME_PASSWORD_ERROR;
      return;
    } else {
      this.errorMessage = false;
      this.showErrorMessage = '';
    }
    const emailId = sessionStorage.getItem('email');
    this.loginService.changePassword(emailId,
      this.changePWDForm.controls.currentPassword.value,
      this.changePWDForm.controls.password.value, this
      );
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
    if (this.fieldTextType) {
      this.displayEyePassword = faEyeSlash;
    } else if (!this.fieldTextType) {
      this.displayEyePassword = faEye;
    }
  }

  toggleRepeatFieldTextType() {
    this.repeatFieldTextType = !this.repeatFieldTextType;
    if (this.repeatFieldTextType) {
      this.displayEyeCnfPassword = faEyeSlash;
    } else if (!this.repeatFieldTextType) {
      this.displayEyeCnfPassword = faEye;
    }
  }

  checkCnfPasswordValidation(cpwValue: string) {
    this.isPasswordMatch = this.changePWDForm.controls.password.value === cpwValue;
    this.errorMessage = false;
    this.showErrorMessage = '';
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  cognitoCallback(message: string, result: any) {
    if (message === undefined) { 
      this.errorMessage = false;
      this.pwdSuccessModal = true;
      this.userAccountTitle = GlobalConstants.PASSWORD_CHANGED_TITLE;
      this.userAccountSuccessMsg = GlobalConstants.PASSWORD_CHANGED_SUCCESS_MSG;
      this.changePwdPopup = false;
      this.showErrorMessage = '';
    } else { 
      this.errorMessage = true;
      this.showErrorMessage = message;
    }

  }

  isLoggedIn(message: string, isLoggedIn: boolean) {​​​​​​​​
    if (!isLoggedIn) {
      this.router.navigate([GlobalConstants.HOME_PAGE]);
    }​​​​​​​​
  }

  getUserAccountDetails() {
    this.myAccountService.getUserAccountDetails()
    .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(userDetails => {
        this.editAccountForm.patchValue({
          firstName: userDetails.user.firstName.trim(),
          lastName: userDetails.user.lastName.trim(),
          email: userDetails.user.email,
          location: userDetails.user.location,
          storeName: userDetails.user.storeName || this.notApplicable,
          retailerName: userDetails.user.retailerName || this.notApplicable,
          emailNotification: userDetails.user.configurations.includes(CreateAccountConstants.TEXT_YES)
        });
        this.locationList.push(userDetails.user.location);
        this.cmnService.setRetailGifValue(false);
      });
  }

  updateUserAccount() {
    
    const inputParams = {
      firstName: this.editAccountForm.controls.firstName.value.trim(),
      lastName: this.editAccountForm.controls.lastName.value.trim(),
      configurations: JSON.stringify({​​​​​​​​email_notifications: (this.editAccountForm.controls.emailNotification.value) ? CreateAccountConstants.TEXT_YES :  CreateAccountConstants.TEXT_NO})
    };

    this.myAccountService.updateAccountDetail(inputParams)
    .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(userResponse => {
        if (userResponse) {
          this.pwdSuccessModal = true;
          this.userAccountTitle = GlobalConstants.ACCOUNT_UPDATED_TITLE;
          this.userAccountSuccessMsg = GlobalConstants.ACCOUNT_UPDATED_SUCCESSFULL;
          sessionStorage.setItem('firstname', this.editAccountForm.controls.firstName.value);
          sessionStorage.setItem('lastname', this.editAccountForm.controls.lastName.value);
        }
      });
  }

  closePwdPopup() {
    this.pwdSuccessModal = false;
  }

  gotoPreviousPage() {
    this.location.back();
  }

  toggleCurrentFieldTextType() {
    this.fieldCurrentTextType = !this.fieldCurrentTextType;
    if (this.fieldCurrentTextType) {
      this.displayCurrEyePassword = faEyeSlash;
    } else if (!this.fieldCurrentTextType) {
      this.displayCurrEyePassword = faEye;
    }
  }

}
